import { motion, AnimatePresence, useAnimation } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import IconArrow from '../icons/icon-arrow';

const variants = {
  from: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.5,
      type: 'tween',
    },
  },
  to: {
    opacity: 1,
    height: 'auto',
    transition: {
      duration: 0.5,
      type: 'tween',
    },
  },
};

const ReadMore = ({ children, excerpt, className, contentClassName }) => {
  const [isRevealed, setIsRevealed] = useState(false);
  const controls = useAnimation();
  const revealMoreHandle = () => setIsRevealed((prev) => !prev);

  useEffect(() => {
    if (isRevealed) {
      controls.start('to');
    } else {
      controls.start('from');
    }
  }, [isRevealed, controls]);

  return (
    <article>
      <div className="blurb space-y-4">{excerpt}</div>

      <AnimatePresence mode="wait" onExitComplete={() => revealMoreHandle(false)}>
        {isRevealed && (
          <motion.div
            variants={variants}
            animate={controls}
            initial="from"
            exit="from"
            className="overflow-hidden"
          >
            <div className={contentClassName}>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
      {children != null && (
        <button
          className={`group mt-5 flex items-center gap-5 after:absolute after:inset-0 after:content-[''] lg:mt-8 xl:mt-10 ${className}`}
          type="button"
          onClick={revealMoreHandle}
        >
          <span className="reveal-text">Read {isRevealed ? 'less' : 'more'}</span>
          <span className="w-4 translate-x-0 transition-all duration-200 group-hover:translate-x-[0.15rem] lg:w-auto">
            <IconArrow className="w-full lg:w-auto" />
          </span>
        </button>
      )}
    </article>
  );
};

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  excerpt: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
};

ReadMore.defaultProps = {
  excerpt: null,
  className: '',
  contentClassName: '',
};
export default ReadMore;
